module.exports = __webpack_public_path__ + "img/logo.b3baff57.png";